import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
  Typography,
  IconButton,
  Divider
} from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import CloseIcon from '@mui/icons-material/Close';
import { CleanButton } from 'src/components/clean/button';

interface PaymentErrorModalProps {
  open: boolean;
  onClose: () => void;
}

const PaymentErrorModal: React.FC<PaymentErrorModalProps> = ({
  open,
  onClose,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="payment-error-dialog-title"
      aria-describedby="payment-error-dialog-description"
      fullWidth
      maxWidth="xs"
      sx={{
        '& .MuiDialog-paper': {
          backgroundColor: 'background.paper',
          boxShadow: '0 8px 16px rgba(0, 0, 0, 0.12)',
          borderRadius: '12px',
        },
      }}
    >
      <DialogTitle
        id="payment-error-dialog-title"
        sx={{
          pb: 1,
          pt: 2,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between'
        }}
      >
        <Typography variant="h6" component="div" sx={{ fontWeight: 600 }}>
          Payment Failed
        </Typography>
        <IconButton
          aria-label="close"
          onClick={onClose}
          edge="end"
          size="small"
          sx={{ color: 'text.secondary' }}
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      </DialogTitle>
      
      <Divider />
      
      <DialogContent sx={{ pt: 3, pb: 2 }}>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'flex-start',
            gap: 2,
            mb: 2
          }}
        >
          <ErrorOutlineIcon
            color="error"
            sx={{
              fontSize: 36,
              mt: 0.5,
              p: 0.5,
              borderRadius: '50%',
              backgroundColor: 'error.light',
              color: 'error.main'
            }}
          />
          <Box>
            <Typography
              variant="body1"
              id="payment-error-dialog-description"
              sx={{
                fontWeight: 700,
                color: 'error.main',
                mb: 1
              }}
            >
              Your payment could not be processed
            </Typography>
            <Typography
              variant="body2"
              sx={{
                color: 'text.primary'
              }}
            >
              Your payment failed to process, please try again or contact your sales associate.
            </Typography>
          </Box>
        </Box>
      </DialogContent>
      
      <DialogActions sx={{ px: 3, pb: 3, pt: 1, justifyContent: 'flex-end' }}>
        <CleanButton 
          onClick={onClose} 
          color="primary" 
          variant="contained"
          aria-label="Close error dialog"
        >
          Close
        </CleanButton>
      </DialogActions>
    </Dialog>
  );
};

export default PaymentErrorModal;